import React, { ReactNode, useCallback } from "react";

import { FunctionComponent } from "../../util";
import "./styles.scss";

export interface InputLabelProps {
  visuallyHidden?: boolean;
  htmlFor?: string;
  className?: string;
  isSpan?: boolean;
  id?: string;
}

const InputLabel: FunctionComponent<InputLabelProps> = ({
  children,
  id,
  htmlFor,
  visuallyHidden,
  className,
  isSpan,
}) => {
  const onClickHandler = useCallback(() => {
    if (!htmlFor) {
      return;
    }
    const labelEl = document.getElementById(htmlFor!);
    labelEl?.focus();
  }, [htmlFor]);

  if (htmlFor && !isSpan) {
    return (
      <label id={id} className={`c-input-label ${visuallyHidden ? "is-sr-only" : ""} ${className}`} htmlFor={htmlFor}>
        {children}
      </label>
    );
  }

  return (
    <span
      onClick={onClickHandler}
      id={id}
      className={`c-input-label ${visuallyHidden ? "is-sr-only" : ""} ${className}`}
    >
      {children}
    </span>
  );
};

export const LabelHeading: FunctionComponent<{ className?: string; level?: number; badges?: ReactNode }> = ({
  className,
  level,
  badges,
  children,
}) => {
  const Tag = level ? `h${level}` : "div";
  return (
    // @ts-ignore - React doesn't recognise `children` when the tag name is a variable.
    <Tag className={`c-input-label ${className}`}>
      <span className="c-input-label__main">{children}</span>
      {badges}
    </Tag>
  );
};

export default InputLabel;
